const config = {
  baseUrl: 'https://beta-api.dimorder.com',
  mpUrl: 'https://beta-mp-order.dimorder.com',
}

export default config
